import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-95';
  const variants = {
    primary: 'bg-red-700 hover:bg-red-800 text-white shadow-lg hover:shadow-xl shadow-red-900/20 focus:ring-red-700',
    secondary: 'bg-green-600 hover:bg-green-700 text-white shadow-md hover:shadow-lg focus:ring-green-600',
    outline: 'border-2 border-red-700 text-red-700 hover:bg-red-50 focus:ring-red-700',
    ghost: 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm rounded-full',
    md: 'h-12 px-6 text-base rounded-full',
    lg: 'h-14 px-8 text-lg rounded-full'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} onClick={props.onClick as any} data-id="element-143">
        {children}
      </a>;
  }
  return <button className={combinedClassName} disabled={disabled || isLoading} {...props} data-id="element-144">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-145" />}
      {children}
    </button>;
}